<!-- 货币基金持仓列表 -->
<template>
  <div class="hold-currency-list">
    <!-- 顶部提示 -->
    <div class="top-tip row">
      <div class="dot"></div>
      <div>期末投资组合平均剩余期限分布</div>
    </div>
    <!-- 列表 -->
    <common-list
      :header-list="headerList"
      :data-source="getDataList()"
      :more-text="'更多持仓信息'"
      :click-track="'xpzy.pzy.gdccxx.click'">
      <template slot="list-item" slot-scope="{item}">
        <div class="list-item row">
          <div class="avg-column">{{item.date}}</div>
          <div class="asset-column">{{item.assetsRatio || '--'}}</div>
          <div class="debt-column">{{item.debtRatio || '--'}}</div>
        </div>
      </template>
    </common-list>
  </div>
</template>

<script>
import CONFIG from '@/configs/default';
import CommonList from '../MarketQuotation/QuotationCommonList.vue';

export default {

  name: 'hold-currency-list',

  components: {
    CommonList,
  },

  props: {
    dataSource: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      headerList: CONFIG.currencyHoldHeaderList || [],
    };
  },

  methods: {
    async getDataList() {
      return this.dataSource.list;
    },
  },
};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.hold-currency-list {
  width: 100%;
  box-sizing: border-box;
  padding-right: 24px;
  margin-top: 30px;
  .top-tip {
    justify-content: flex-start;
    font-size: 30px;
    color: #000000;
    line-height: 38px;
    .dot {
      width: 10px;
      height: 10px;
      background-color: #f96b36;
      border-radius: 5px;
      margin-right: 8px;
    }
  }
  .list-item {
    justify-content: space-between;
    padding: 16px 0 24px;
    font-family: DINAlternate-Bold;
    font-size: 30px;
    color: #000000;
    .avg-column {
      flex: 3;
      font-family: PingFangSC-Regular;
    }
    .asset-column {
      flex: 2;
      font-size: 32px;
      text-align: center;
    }
    .debt-column {
      flex: 2;
      text-align: right;
    }
  }
}
</style>
